import { Modal } from '@platform/components';
import { navigate } from 'wouter/use-browser-location';
import { ROUTES } from '../routes/consts';
import { Organizations, Users } from '@platform/client';
import { useApplicationLocalStorage } from '../application/application-hook';

type SaveAndExitModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  isRep?: boolean;
  onSubmit: () => void;
};
export const ProfileSaveAndExitModal = (props: SaveAndExitModalProps) => {
  const { isOpen, closeModal, isRep, onSubmit } = props;
  const { getApplicationData } = useApplicationLocalStorage();

  const repProfileUpdateMutator = Organizations.useUpdateOrganizationProfile({
    mutation: {
      onSuccess: () => {
        navigate(`platform${ROUTES.DASHBOARD}`);
      },
    },
  });

  const proProfileUpdateMutator = Users.useUpdateProfile({
    mutation: {
      onSuccess: () => {
        navigate(`platform${ROUTES.DASHBOARD}`);
      },
    },
  });

  const onSaveExit = async () => {
    // onSubmit here ensures local storage is updated before we fetch it and send data to API
    await onSubmit();
    const profileData = getApplicationData();
    if (isRep) {
      repProfileUpdateMutator.mutate({
        data: { ...profileData },
      });
    } else {
      proProfileUpdateMutator.mutate({
        data: { ...profileData },
      });
    }
  };

  return (
    <Modal
      variant='dialog'
      title='Save profile changes'
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      ignoreExtraPadding={true}
      primaryCTA={{
        text: 'Update profile',
        callback: onSaveExit,
      }}
      secondaryCTA={{
        text: 'Continue editing',
        callback: closeModal,
      }}
    >
      <div className='flex flex-col gap-4 w-full text-center h-full'>
        <div>Select update profile to save your changes and return to the dashboard</div>
      </div>
    </Modal>
  );
};
